import React, { PureComponent } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import get from 'lodash/get';
import { withRouter } from 'react-router-dom';

import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { getBreakdownTypes } from 'modules/dictionary/services/dictionary.service';
import Modal from 'modules/app/components/modal.component';
import {
  Input, Datepicker, FormDetailsItem, Table, FormDetailsLink,
} from '../../common/components';
import {
  getBreakdown, saveBreakdownStatus, updateBreakdown, getBreakdownStatuses, deleteBreakdown,
} from '../services/breakdown.service';
import { BREAKDOWN_STATUSES } from '../../app/config/config';
import PriceForm from './priceForm.component';

const DISPLAY_STATUSES = [1, 2];

const TABLE_CONFIG_BREAKDOWN_STATUSES = {
  columns: [
    {
      caption: 'Data',
      dataField: 'date',
      sort: true,
    },
    {
      caption: 'Opis',
      dataField: 'notes',
    },
    {
      caption: 'Użytkownik',
      dataField: 'user.name',
    },
  ],
  noItemsFoundText: 'Brak elementów do wyświetlenia',
  initialSort: {
    sortField: 'date',
    sortDirection: 'asc',
  },
  filterFields: 'notes,user.name',
};

class BreakdownDetails extends PureComponent {
  state = {
    data: {},
    isLoading: true,
    modalVisible: false,
    breakdownTypes: [],
  }

  id = this.props.match.params.id;

  async componentDidMount() {
    await this.getData();
  }

  getData = async () => {
    try {
      const { match: { params } } = this.props;

      this.setState({
        isLoading: true,
      });

      const data = await getBreakdown(params.id);
      const { data: breakdownTypes } = await getBreakdownTypes();
      this.setState({
        data,
        breakdownTypes,
        isLoading: false,
      });
    } catch (error) {
      console.error(error);
    }
  }

  getBreakdownStatuses = async (requestParams) => {
    try {
      const { match: { params } } = this.props;

      this.setState({
        isLoading: true,
      });

      const { data } = await getBreakdownStatuses({ breakdown: params.id, ...requestParams });

      this.setState({
        data: {
          ...this.state.data,
          breakdownStatuses: data,
        },
        isLoading: false,
      });
    } catch (error) {
      this.setState({ isLoading: false });
      console.error(error);
    }
  }

  onInputChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  }

  saveStatus = async () => {
    try {
      const { data: { id }, date = new Date(), notes } = this.state;

      await saveBreakdownStatus({ id, date, notes });

      this.setState({
        date: new Date(),
        notes: '',
      }, async () => {
        await this.getData();
        toast.success('Notatka została dodana');
      });
    } catch (error) {
      console.error(error);
    }
  }

  handleStatusChange = async (event) => {
    try {
      const { target: { id } } = event;
      const { match: { params }, isAdmin } = this.props;

      await updateBreakdown({ id: params.id, status: id });

      toast.success('Status został zaktualizowany');
      if (isAdmin && BREAKDOWN_STATUSES[id] === 'Zamknięta') {
        this.setState({
          modalVisible: true,
        });
      }
      await this.getData();
    } catch (error) {
      console.error(error);
    }
  }

  handleGroupChange = async (event) => {
    try {
      const { target: { id } } = event;
      const { match: { params } } = this.props;
      await updateBreakdown({ id: params.id, type: id });

      toast.success('Grupa awarii został zaktualizowana');
      await this.getData();
    } catch (error) {
      console.error(error);
    }
  }

  handleDelete = async () => {
    try {
      const { history, match: { params } } = this.props;
      const confirm = window.confirm('Czy chcesz usunąć awarię?');

      if (confirm) {
        await deleteBreakdown(params.id);
      }

      toast.success('Awaria została usunięta');

      history.push('/breakdowns');
    } catch (error) {
      toast.error('Wystąpił bład podczas usuwania.');
      console.error(error);
    }
  }

  render() {
    const { data, date, notes, isLoading, modalVisible, breakdownTypes } = this.state;

    const { isAdmin, match: { params } } = this.props;
    return (
      <>
        <div className="content">
          <div className="card-header row no-gutters justify-content-between align-items-center py-2">
            Szczegóły awarii
            {isAdmin && (
              <div className="d-flex">
                <div className="dropdown mr-2">
                  <button className="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Ustaw grupę
                  </button>
                  <div className="dropdown-menu dropdown-scrollable drop" aria-labelledby="dropdownMenuButton">
                    {breakdownTypes.map((type) => <div key={type.id} id={type.id} onClick={this.handleGroupChange} className="dropdown-item">{type.name}</div>)}
                  </div>
                </div>
                <div className="dropdown">
                  <button className="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Zmień status
                  </button>
                  <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    {Object.values(BREAKDOWN_STATUSES).map((status, index) => <div key={index} id={index} onClick={this.handleStatusChange} className="dropdown-item">{status}</div>)}
                  </div>
                </div>
                <button className="btn btn-outline-danger ml-2" type="button" onClick={this.handleDelete}>
                  Usuń
                </button>
              </div>
            )}

          </div>
          <div className="card">
            <div className="card-body">
              <FormDetailsItem label="Samochód" value={`${get(data, 'car.manufacturer.name')} ${get(data, 'car.model.name')}`} />
              <FormDetailsLink label="VIN" value={`${get(data, 'car.vin')}`} href={`/car-details/${get(data, 'car.id')}`} />
              <FormDetailsItem label="Email" value={get(data, 'email')} />
              <FormDetailsItem label="Telefon" value={get(data, 'phone')} />
              <FormDetailsItem label="Miejscowość i kod wystąpienia" value={`${get(data, 'incidentPlace')}, ${get(data, 'incidentPostal')}`} />
              <FormDetailsItem label="Status" value={BREAKDOWN_STATUSES[get(data, 'status')]} />
              <FormDetailsItem label="Dodatkowe informacje" value={get(data, 'notes')} />
              {isAdmin && <FormDetailsItem label="Cena" value={get(data, 'price')} />}
              <FormDetailsItem label="Grupa Awarii" value={get(data, 'type.name') || 'Nie ustawiona'} />
            </div>
          </div>
        </div>
        <Modal isVisble={modalVisible} title="SetPrice">
          <PriceForm breakdownId={params.id} refresh={this.getData} closeModal={() => this.setState({ modalVisible: false })} />
        </Modal>
        <div className="content">
          <div className="card">
            <div className="card-header row no-gutters align-items-center justify-content-between py-3">
              Historia
            </div>
            <div className="card-body">
              <Table
                config={TABLE_CONFIG_BREAKDOWN_STATUSES}
                items={get(data, 'breakdownStatuses', [])}
                fetchData={this.getBreakdownStatuses}
                isLoading={isLoading}
                pagination
              />
            </div>
          </div>
        </div>

        {DISPLAY_STATUSES.includes(data.status)
          && (
            <div className="content">
              <div className="card-header row no-gutters justify-content-between align-items-center py-2">
                Dodaj notatke
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="form-horizontal">
                    <Datepicker
                      selected={date || new Date()}
                      id="date"
                      label="Data"
                      maxDate={new Date()}
                      onChange={this.onInputChange}
                    />

                    <Input
                      controlType="textarea"
                      label="Dodatkowe informacje"
                      id="notes"
                      value={notes}
                      onChange={this.onInputChange}
                    />

                    <div className="form-group float-right">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={this.saveStatus}
                      >
                        Dodaj
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
      </>
    );
  }
}

BreakdownDetails.defaultProps = {
  isAdmin: false,
};

BreakdownDetails.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
  isAdmin: PropTypes.bool,
};

export default withRouter(BreakdownDetails);
